/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Authority } from './authority';


export interface UserRole { 
    userRole?: string;
    authorities?: Array<Authority>;
}

